/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SplitSimpleFromRocketReqApplyGoodsForSimpleVo } from './SplitSimpleFromRocketReqApplyGoodsForSimpleVo';
import {
    SplitSimpleFromRocketReqApplyGoodsForSimpleVoFromJSON,
    SplitSimpleFromRocketReqApplyGoodsForSimpleVoFromJSONTyped,
    SplitSimpleFromRocketReqApplyGoodsForSimpleVoToJSON,
    SplitSimpleFromRocketReqApplyGoodsForSimpleVoToJSONTyped,
} from './SplitSimpleFromRocketReqApplyGoodsForSimpleVo';
import type { OrderReceiveAddressVo } from './OrderReceiveAddressVo';
import {
    OrderReceiveAddressVoFromJSON,
    OrderReceiveAddressVoFromJSONTyped,
    OrderReceiveAddressVoToJSON,
    OrderReceiveAddressVoToJSONTyped,
} from './OrderReceiveAddressVo';

/**
 * 
 * @export
 * @interface SplitSimpleFromRocketReqVo
 */
export interface SplitSimpleFromRocketReqVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof SplitSimpleFromRocketReqVo
     */
    orderId?: number;
    /**
     * 快递件申请单ID
     * @type {number}
     * @memberof SplitSimpleFromRocketReqVo
     */
    orderSimpleRequisitionId?: number;
    /**
     * 申请商品列表
     * @type {Array<SplitSimpleFromRocketReqApplyGoodsForSimpleVo>}
     * @memberof SplitSimpleFromRocketReqVo
     */
    applyGoods?: Array<SplitSimpleFromRocketReqApplyGoodsForSimpleVo>;
    /**
     * 
     * @type {OrderReceiveAddressVo}
     * @memberof SplitSimpleFromRocketReqVo
     */
    receiveAddress?: OrderReceiveAddressVo;
}

/**
 * Check if a given object implements the SplitSimpleFromRocketReqVo interface.
 */
export function instanceOfSplitSimpleFromRocketReqVo(value: object): value is SplitSimpleFromRocketReqVo {
    return true;
}

export function SplitSimpleFromRocketReqVoFromJSON(json: any): SplitSimpleFromRocketReqVo {
    return SplitSimpleFromRocketReqVoFromJSONTyped(json, false);
}

export function SplitSimpleFromRocketReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SplitSimpleFromRocketReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderSimpleRequisitionId': json['orderSimpleRequisitionId'] == null ? undefined : json['orderSimpleRequisitionId'],
        'applyGoods': json['applyGoods'] == null ? undefined : ((json['applyGoods'] as Array<any>).map(SplitSimpleFromRocketReqApplyGoodsForSimpleVoFromJSON)),
        'receiveAddress': json['receiveAddress'] == null ? undefined : OrderReceiveAddressVoFromJSON(json['receiveAddress']),
    };
}

export function SplitSimpleFromRocketReqVoToJSON(json: any): SplitSimpleFromRocketReqVo {
    return SplitSimpleFromRocketReqVoToJSONTyped(json, false);
}

export function SplitSimpleFromRocketReqVoToJSONTyped(value?: SplitSimpleFromRocketReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderSimpleRequisitionId': value['orderSimpleRequisitionId'],
        'applyGoods': value['applyGoods'] == null ? undefined : ((value['applyGoods'] as Array<any>).map(SplitSimpleFromRocketReqApplyGoodsForSimpleVoToJSON)),
        'receiveAddress': OrderReceiveAddressVoToJSON(value['receiveAddress']),
    };
}

